import { useCallback } from 'react';
import { DATASET_KEY, LINKED_DATASETS_KEY } from '@/utils/queryKeys.ts';

import { LinkedDataset } from '@/types/datasets.ts';

const useInvalidateLinkedDataset = (automationId: string) => {
  return useCallback(
    (linkedDataset: LinkedDataset): unknown[][] => {
      const keys: (string | undefined)[][] = [LINKED_DATASETS_KEY(automationId)];
      if (linkedDataset.latest_dataset) {
        keys.push(DATASET_KEY(linkedDataset.latest_dataset.id));
      }
      return keys;
    },
    [automationId],
  );
};

export default useInvalidateLinkedDataset;
